<template>
  <!-- fullstory: fs-mask keeps driver contact pii (names / phones / emails) out of recordings -->
  <div style="min-height: 100vh; background: #f4f7fa; font-family: sans-serif;" class="fs-mask">

    <!-- header bar -->
    <div style="background: #6095c1; padding: 16px 24px; display: flex; align-items: center; gap: 12px;">
      <img src="/favicon-white.png" style="width: 36px; height: 36px;" alt="Fleet Integrations" />
      <div>
        <div style="color: #fff; font-size: 18px; font-weight: 700; line-height: 1.2;">Driver Contact Directory</div>
        <div style="color: rgba(255,255,255,0.75); font-size: 12px; letter-spacing: 0.3px;">
          {{ tenant_name ? tenant_name + ' · ' : '' }}Fleet Integrations
        </div>
      </div>
    </div>

    <!-- body -->
    <div style="max-width: 640px; margin: 0 auto; padding: 28px 20px;">

      <div v-if="loading" style="color: #888; font-size: 14px; padding: 32px 0; text-align: center;">Loading...</div>

      <div v-else-if="error" style="background: #fdecea; border: 1px solid #f5c6cb; border-radius: 6px; padding: 14px 16px; color: #c0392b; font-size: 14px;">{{ error }}</div>

      <div v-else>
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px;">
          <span style="color: #555; font-size: 13px;">{{ filtered_drivers.length }} of {{ drivers.length }} drivers</span>
        </div>

        <input
          v-model="search"
          type="text"
          placeholder="Search by name or phone..."
          style="width: 100%; box-sizing: border-box; padding: 9px 13px; font-size: 14px; border: 1.5px solid #b8d0e4; border-radius: 6px; margin-bottom: 16px; outline: none; background: #fff;"
        />

        <div style="background: #fff; border-radius: 8px; border: 1px solid #dde6ef; overflow: hidden;">
          <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
            <thead>
              <tr style="background: #eef4fb; border-bottom: 1px solid #dde6ef; text-align: left;">
                <th style="padding: 10px 16px; color: #4a6fa5; font-weight: 600; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Name</th>
                <th style="padding: 10px 16px; color: #4a6fa5; font-weight: 600; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Phone</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(driver, i) in filtered_drivers"
                :key="driver.name"
                :style="{ borderBottom: '1px solid #eef1f5', background: i % 2 === 0 ? '#fff' : '#fafcff' }"
              >
                <td style="padding: 11px 16px; color: #222;">{{ driver.name }}</td>
                <td style="padding: 11px 16px;">
                  <span
                    v-if="driver.phone"
                    @click="copy_phone(driver)"
                    :title="copied === driver.name ? 'Copied!' : 'Click to copy'"
                    style="color: #6095c1; font-weight: 500; cursor: pointer; user-select: none;"
                  >{{ copied === driver.name ? '✓ Copied' : driver.phone }}</span>
                  <span v-else style="color: #bbb;">—</span>
                </td>
              </tr>
              <tr v-if="filtered_drivers.length === 0">
                <td colspan="2" style="padding: 24px 16px; color: #aaa; font-style: italic; text-align: center;">No drivers match your search.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { get_driver_contacts } from '../networking/apis'

export default {
  name: 'driver_contacts',
  metaInfo: {
    title: 'Driver Contact Directory',
    titleTemplate: 'Driver Contact Directory',
  },
  data() {
    return {
      drivers: [],
      tenant_name: '',
      search: '',
      loading: true,
      error: null,
      copied: null,
    }
  },
  methods: {
    copy_phone(driver) {
      navigator.clipboard.writeText(driver.phone).then(() => {
        this.copied = driver.name
        setTimeout(() => { this.copied = null }, 2000)
      })
    },
  },
  computed: {
    filtered_drivers() {
      const q = this.search.trim().toLowerCase()
      if (!q) return this.drivers
      return this.drivers.filter(d =>
        d.name.toLowerCase().includes(q) || (d.phone || '').includes(q)
      )
    },
  },
  async mounted() {
    const token = this.$route.path.split('/driver-contacts/')[1]
    if (!token) {
      this.error = 'Invalid link.'
      this.loading = false
      return
    }
    try {
      const { value: { data = {} } } = await get_driver_contacts(token)
      this.drivers = data.drivers || []
      this.tenant_name = data.tenant_name || ''
    } catch (e) {
      this.error = 'This link is invalid or has expired. Please contact your administrator.'
    } finally {
      this.loading = false
    }
  },
}
</script>
